export default {
  data() {
    return {
      renderValue: [],
    }
  },

  props: {
    transform: Boolean,

    number: Boolean,

    getter: {
      type: Function,
      default: val => val ? val.split(',').map(n => this.number ? parseFloat(n) : n) : []
    },

    setter: {
      type: Function,
      default: val => val.join(',')
    },
  },

  methods: {
    onInputChange(value) {
      this._initialValue = true

      if (this.transform) {
        this.renderValue = value
        value = this.setter(value)

      }

      if (!this.multiple && value instanceof Array && value.length > 1) {
        value = value.splice(1, 1)

      }

      this.$emit('input', value)

      this.syncLabel(value)

      this.debounceValidate()
    },
    syncLabel(value) {
      if (this.multiple) {
        const map = this.renderValues.filter(p => value.find(item => p[this.valueField] === item)).map(data => data[this.textField])
        if (map) {
          let maps = Array.from(new Set(map))
          this.$emit('update:labels', maps.join(';'))
        }
      } else {
        const temp = this.renderValues.find(p => p[this.valueField] === value)
        if (temp) {
          this.$emit('update:labels', temp[this.textField])
        }
      }
    }
  },

  watch: {
    value: {
      handler(val) {
        if (!this._initialValue && val) {
          this.initialValue = val
          this._initialValue = true
        }

        if (this.transform) {
          this.renderValue = this.getter(val).map(n => this.number ? parseFloat(n) : n)
        } else {
          this.renderValue = val
        }
      },
      immediate: true,
    },
  },
}
